module.exports = __webpack_public_path__ + "static/media/kid-with-phone.4ee0b878.jpg";